import http from '@/plugins/http-common'
import {ResponseData} from './types'

type CreateParams = {
    order_id: number,
}

class PromotionService {
    getList = (): Promise<ResponseData> => http.get('/promotions/list')
    create = (params: CreateParams): Promise<ResponseData> => http.get('/orders', {params})
}

export default new PromotionService()
